import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import { Reset } from './reset.action';

// TODO revise. use reload instead???
export function resetReducer(
    state: TranscriptDialogState,
    _: PayloadAction<ActionType.COACHING_DETAIL__TD__RESET, Reset>,
): TranscriptDialogState {
    try {
        return {
            ...state,
            pending: {},
            filteredQuotes:
                state.transcript?.quotes != null
                    ? [...state.transcript.quotes]
                    : [],
            filterOpts: {},
            sliderOptions: {
                floorNum: 0,
                ceilNum:
                    state.transcript?.quotes == null ||
                    state.transcript.quotes.length === 0
                        ? 1
                        : (state.transcript.quotes.at(-1)?.endTime?.getTime() -
                              state.transcript.quotes[0]?.endTime?.getTime()) /
                          1000,
            },
            selectedQuotes: undefined,
            filteredQuotesSelectedLookup: {},
            allQuotesAreSelected: undefined,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
